import { useEffect, useState } from 'react';
import { type IAlertBannerProps } from './AlertBanner.types';

const AlertBanner: React.FC<IAlertBannerProps> = ({
  text,
  textMobile,
  link,
  linkText,
  contactText,
  contactUrl,
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!textMobile && windowWidth < 768) {
    return null;
  }

  if (text || linkText || textMobile) {
    return (
      <div className="alert-banner">
        <div className="alert-banner__container container">
          <p className="alert-banner__content">
            {text && (
              <span className="alert-banner__text alert-banner__text--desktop">
                {text}
              </span>
            )}
            {textMobile && (
              <span className="alert-banner__text alert-banner__text--mobile">
                {textMobile || text}
              </span>
            )}

            {link && (
              <a href={link} className="alert-banner__link">
                {linkText}
              </a>
            )}
          </p>

          {contactText && contactUrl && contactUrl !== '/' && (
            <p className="alert-banner__content">
              <a href={contactUrl} className="alert-banner__cta">
                {contactText}
              </a>
            </p>
          )}
        </div>
      </div>
    );
  }
};

export default AlertBanner;
